import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {};

// Dynamically import all translation files from the general folder
const requireGeneralContext = require.context('./translations/general', false, /\.js$/);

requireGeneralContext.keys().forEach(fileName => {
  const locale = fileName.replace('./', '').replace('.js', '');
  if (messages[locale] === undefined) {
    messages[locale] = {};
  }
  messages[locale] = { ...requireGeneralContext(fileName).default, ...messages[locale] };
});

// Dynamically import all translation files from other folders
const requireContext = require.context('./translations', true, /\.js$/);

requireContext.keys().forEach(fileName => {
  const match = fileName.match(/\.\/([^/]+)\/([a-z]{2})\.js$/);
  if (match) {
    const folder = match[1];
    const locale = match[2];
    if (messages[locale] === undefined) {
      messages[locale] = {};
    }
    if (messages[locale][folder] === undefined) {
      messages[locale][folder] = {};
    }
    messages[locale][folder] = { ...requireContext(fileName).default, ...messages[locale][folder] };
  }
});

const i18n = new VueI18n({
  locale: 'en', // set default locale
  messages,
});

export default i18n;